export const headerTranslations = {
    en: {
        header: {
            title: 'Part Plan And Zone Certificate Portal',
            subtitle: 'Sangli, Miraj and Kupwad Municipal Corporation',
            subSubtitle: 'Town Planning Department',
            applicantLogin: 'Applicant Login',
            officeLogin: 'Office Login',
            home: 'HOME',
            faq: 'FAQ',
            contact: 'CONTACT US',
            userGuide: 'User Guide'
        },


    },
    mr: {
        header: {
            title: 'भाग नकाशा आणि झोन दाखला पोर्टल',
            subtitle: 'महाराष्ट्र शासन',
            subSubtitle: 'नगर रचना आणि मूल्य निर्धारण विभाग',
            applicantLogin: 'अर्जदार लॉगिन',
            officeLogin: 'कार्यालय लॉगिन',
            home: 'मुख्यपृष्ठ',
            faq: 'सामान्य प्रश्न',
            contact: 'संपर्क करा',
            userGuide: 'वापरकर्ता मार्गदर्शक'
        },

    }
};
